export const contentItems = [
  {
    id: 'mv-star-echo',
    type: 'movie',
    title: '星际回声',
    subtitle: '当宇宙回望时，我们听见了自己',
    cover: 'https://readdy.ai/api/search-image?query=Minimal%20cinematic%20sci-fi%20movie%20poster%20art%2C%20lone%20astronaut%20silhouette%20standing%20before%20a%20glowing%20amber%20nebula%2C%20deep%20charcoal%20background%2C%20warm%20orange%20and%20gold%20light%20rays%2C%20high%20contrast%2C%20elegant%20graphic%20composition%2C%20no%20text&width=600&height=900&seq=dollfilm-mv-star-echo&orientation=portrait',
    summary: '一支深空探测队在被遗忘的星域捕捉到来自人类自身频率的回声，关于记忆与归途的硬科幻命题由此展开。',
    genre: ['科幻', '剧情'],
    year: 2026,
    region: '中国',
    rating: 9.1,
    duration: '142 分钟',
    director: '陈叙白',
    cast: ['沈知遥', '陆行舟', '白芷', '季岸'],
    heat: 98,
    featured: true,
    synopsis: [
      '近未来，深空探测计划「回响」在木星轨道外接收到一段规律信号，频率竟然与二十年前失联的探测船完全一致。船长林桡带着三名队员穿越尘埃带，去寻找那艘本该消失的飞船。',
      '越靠近信号源，他们越发现记忆正在被改写：同一个人拥有两段童年，同一段历史出现两种结局。影片用极简的太空场景承载最浓烈的情感，把「回家」这件事拆解成一次关于自我确认的旅程。',
    ],
  },
  {
    id: 'mv-long-night',
    type: 'movie',
    title: '长夜将尽',
    subtitle: '一个雨夜，七个人，一个谎言',
    cover: 'https://readdy.ai/api/search-image?query=Moody%20crime%20thriller%20movie%20poster%2C%20lone%20figure%20with%20umbrella%20on%20rain-soaked%20street%20at%20night%2C%20warm%20amber%20streetlights%20reflecting%20on%20wet%20asphalt%2C%20deep%20shadow%2C%20cinematic%20high%20contrast%2C%20no%20text&width=600&height=900&seq=dollfilm-mv-long-night&orientation=portrait',
    summary: '一场持续整夜的暴雨困住七个陌生人，便利店里的监控录像成为解开旧案唯一的钥匙。',
    genre: ['悬疑', '犯罪'],
    year: 2025,
    region: '中国',
    rating: 8.7,
    duration: '128 分钟',
    director: '何砚',
    cast: ['周序', '林蔓', '赵允之'],
    heat: 94,
    featured: true,
    synopsis: [
      '暴雨导致山体塌方，省道被封。七个原本毫无交集的人被迫滞留在公路旁的便利店里，直到有人在货架后发现了一台仍在运行的旧摄像机。',
      '摄像机里存着三年前一桩悬案的画面，而被拍摄的人，此刻正站在收银台后。影片几乎全部发生在同一个空间内，靠对话与光影推进，把每个人都变成了嫌疑人。',
    ],
  },
  {
    id: 'mv-mountain-sea',
    type: 'movie',
    title: '山海之间',
    subtitle: '我们隔着一整片海，也隔着一整个青春',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20drama%20film%20poster%2C%20two%20figures%20standing%20on%20a%20coastal%20cliff%20at%20golden%20hour%2C%20misty%20warm%20light%2C%20soft%20orange%20sky%2C%20delicate%20minimal%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=dollfilm-mv-mountain-sea&orientation=portrait',
    summary: '海岛少年与内陆女孩用十二年的信，换来了一个夏天的重逢，也换来了一场体面的告别。',
    genre: ['爱情', '剧情'],
    year: 2025,
    region: '中国',
    rating: 8.4,
    duration: '119 分钟',
    director: '苏木',
    cast: ['叶知秋', '顾南', '许清和'],
    heat: 90,
    synopsis: [
      '十二年前，岛上的少年把第一封信塞进漂流瓶；十二年后，已经成为海洋研究员的女孩带着那只瓶子回到了岛上。',
      '影片没有激烈的冲突，只有潮汐、渔船和漫长的夏天。两个人的重逢并不为了在一起，而是为了把当年没能说出口的那句话，好好说完。',
    ],
  },
  {
    id: 'mv-city-goodnight',
    type: 'movie',
    title: '城市最后一次晚安',
    subtitle: '凌晨三点，这座城市还醒着',
    cover: 'https://readdy.ai/api/search-image?query=Urban%20romance%20movie%20poster%2C%20city%20skyline%20at%20dusk%20with%20warm%20glowing%20windows%2C%20tiny%20silhouette%20on%20a%20rooftop%2C%20amber%20and%20cream%20color%20palette%2C%20cinematic%20atmosphere%2C%20no%20text&width=600&height=900&seq=dollfilm-mv-city-goodnight&orientation=portrait',
    summary: '深夜电台主播与代驾司机在同一座城市里错过了一百次，终于在最后一次直播中说了声晚安。',
    genre: ['爱情', '都市'],
    year: 2024,
    region: '中国',
    rating: 8.2,
    duration: '112 分钟',
    director: '程既白',
    cast: ['温言', '柏川', '孟晓'],
    heat: 86,
    synopsis: [
      '电台主播每晚三点的节目只有不到十个听众，其中一个是总在路上的代驾司机。他们从未见过面，却熟悉彼此生活里所有的细节。',
      '当电台即将停播，两人在城市的不同角落开始了一场没有约定的寻找。影片把夜晚的街道拍得温柔又空旷，是写给所有夜归人的一封情书。',
    ],
  },
  {
    id: 'mv-last-laugh',
    type: 'movie',
    title: '笑到最后',
    subtitle: '一个失败的喜剧演员，决定认真难过一次',
    cover: 'https://readdy.ai/api/search-image?query=Playful%20comedy%20film%20poster%2C%20bright%20warm%20orange%20backdrop%20with%20abstract%20geometric%20shapes%2C%20a%20single%20microphone%20stand%20in%20spotlight%2C%20cheerful%20retro%20graphic%20style%2C%20no%20text&width=600&height=900&seq=dollfilm-mv-last-laugh&orientation=portrait',
    summary: '过气喜剧演员被邀请参加一档真人秀，却发现节目组真正想拍的，是他崩溃的那一刻。',
    genre: ['喜剧', '剧情'],
    year: 2025,
    region: '中国',
    rating: 8.0,
    duration: '106 分钟',
    director: '马识途',
    cast: ['罗大川', '钱多多', '孙一鸣'],
    heat: 82,
    synopsis: [
      '曾经红极一时的喜剧演员老罗，如今只能在小剧场里对着七个观众讲段子。一档热门真人秀找上门来，条件是全程跟拍他的「真实生活」。',
      '镜头越来越多，笑声越来越少。老罗最终在直播现场放下话筒，讲了一个不好笑的故事，却让所有人记住了他。',
    ],
  },
  {
    id: 'mv-deep-train',
    type: 'movie',
    title: '深海列车',
    subtitle: '终点站，是海平面以下三千米',
    cover: 'https://readdy.ai/api/search-image?query=Futuristic%20action%20movie%20poster%2C%20streamlined%20train%20speeding%20through%20a%20glowing%20underwater%20tunnel%2C%20warm%20amber%20interior%20lights%20against%20deep%20steel%20tones%2C%20dramatic%20motion%20blur%2C%20cinematic%20sci-fi%2C%20no%20text&width=600&height=900&seq=dollfilm-mv-deep-train&orientation=portrait',
    summary: '一列通往海底科研站的高速列车遭遇袭击，唯一知情的是个被押送的前工程师。',
    genre: ['动作', '科幻'],
    year: 2026,
    region: '中国',
    rating: 8.5,
    duration: '134 分钟',
    director: '韩彻',
    cast: ['江野', '宋莳', '仇天'],
    heat: 92,
    featured: true,
    synopsis: [
      '连接大陆与海底科研站的「潮汐线」是全球最深的载人隧道列车。首航当天，一伙武装人员控制了车厢，目标直指海沟深处的某个装置。',
      '被押送去服刑的前工程师成了唯一能手动切换轨道的人。他必须在四十分钟内判断：究竟谁才是真正的劫持者。',
    ],
  },
  {
    id: 'mv-spring-tide',
    type: 'movie',
    title: '春潮',
    subtitle: '有些告别，要等一整个春天',
    cover: 'https://readdy.ai/api/search-image?query=Quiet%20drama%20film%20poster%2C%20vast%20field%20of%20golden%20grass%20with%20a%20lone%20figure%20walking%2C%20soft%20warm%20afternoon%20light%2C%20hazy%20sun%2C%20minimal%20melancholic%20mood%2C%20film%20photography%2C%20no%20text&width=600&height=900&seq=dollfilm-mv-spring-tide&orientation=portrait',
    summary: '母亲去世后，三个性格迥异的子女回到北方小城，用一整个春天处理一间老房子。',
    genre: ['剧情', '家庭'],
    year: 2024,
    region: '中国',
    rating: 8.8,
    duration: '124 分钟',
    director: '李晚舟',
    cast: ['赵静姝', '陈立', '苏禾'],
    heat: 79,
    synopsis: [
      '母亲留下的老房子要拆迁，三个多年不来往的兄妹被迫在同一屋檐下住了四十天。整理遗物的过程，也是重新认识彼此的过程。',
      '影片用极安静的方式讲述家庭关系，没有控诉，只有一桌逐渐变热的饭菜带来的和解。',
    ],
  },
  {
    id: 'mv-midnight-express',
    type: 'movie',
    title: '午夜快车',
    subtitle: '这座城市入睡之后，另一批人开始上班',
    cover: 'https://readdy.ai/api/search-image?query=Action%20crime%20movie%20poster%2C%20motorcycle%20rider%20on%20wet%20city%20asphalt%20at%20night%2C%20streaking%20orange%20streetlights%2C%20rain%20spray%2C%20dark%20moody%20tones%20with%20vivid%20amber%20highlights%2C%20cinematic%20motion%2C%20no%20text&width=600&height=900&seq=dollfilm-mv-midnight-express&orientation=portrait',
    summary: '一名夜班急救员无意中接下了一单「运送」，从此被卷进城市的暗面。',
    genre: ['动作', '犯罪'],
    year: 2025,
    region: '中国',
    rating: 8.1,
    duration: '116 分钟',
    director: '韩彻',
    cast: ['江野', '程一诺', '沙立'],
    heat: 84,
    synopsis: [
      '急救员阿野习惯在深夜的城市里飞驰。一次出车，他救下的病人把一个箱子塞进他怀里，随后整座城市的追兵都动了起来。',
      '四十公里的城市环线、一个不能停的夜晚。影片用实拍追逐撑起了国产动作片少见的凌厉节奏。',
    ],
  },
  {
    id: 'tv-fog-harbor',
    type: 'tvshow',
    title: '雾港迷案',
    subtitle: '雾散之前，没有人是清白的',
    cover: 'https://readdy.ai/api/search-image?query=Crime%20suspense%20series%20poster%2C%20foggy%20harbor%20at%20dawn%20with%20an%20old%20lighthouse%2C%20silhouetted%20fishing%20boats%2C%20muted%20grey%20and%20warm%20amber%20palette%2C%20moody%20cinematic%20atmosphere%2C%20no%20text&width=600&height=900&seq=dollfilm-tv-fog-harbor&orientation=portrait',
    summary: '北方港口小城连续发生失踪案，一位被降职的老刑警和新人女警在浓雾中拼出真相。',
    genre: ['悬疑', '犯罪'],
    year: 2026,
    region: '国产',
    rating: 9.0,
    seasons: 1,
    episodes: 16,
    status: '连载',
    director: '邵川',
    cast: ['雷万山', '顾清', '孟海'],
    heat: 96,
    featured: true,
    synopsis: [
      '雾港的雾一年有八个月不散。三起相隔十年的失踪案在同一个码头被发现关联，而所有卷宗上签字的，是同一位已经退休的所长。',
      '被贬到档案室的老刑警重新翻出这些泛黄的纸页，和刚刚分配到所里的女警组成了一个不被承认的专案组。',
    ],
  },
  {
    id: 'tv-changan-lantern',
    type: 'tvshow',
    title: '长安灯下',
    subtitle: '灯亮十二时辰，人间百年烟火',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20poster%2C%20ornate%20ancient%20palace%20corridor%20with%20hanging%20lanterns%2C%20rich%20vermilion%20and%20warm%20gold%20tones%2C%20silk%20fabrics%2C%20cinematic%20traditional%20aesthetic%2C%20no%20text&width=600&height=900&seq=dollfilm-tv-changan-lantern&orientation=portrait',
    summary: '上元灯节前夜，长安城一名小吏在十二个时辰内追查一桩牵连朝野的灯市命案。',
    genre: ['古装', '悬疑'],
    year: 2025,
    region: '国产',
    rating: 8.9,
    seasons: 2,
    episodes: 36,
    status: '完结',
    director: '裴之',
    cast: ['谢照', '沈明烛', '柳三娘'],
    heat: 93,
    synopsis: [
      '上元节的花灯还未点亮，西市的工匠先死在了自己的作坊里。负责灯市的小吏被迫在十二个时辰内找出凶手，否则灯会取消，整座城的生计都要断。',
      '案件从市井一直牵到宫墙之内。剧集用一盏灯串起长安的众生相，把盛唐的繁华与暗影同时摆在了灯下。',
    ],
  },
  {
    id: 'tv-our-summer',
    type: 'tvshow',
    title: '我们的夏天',
    subtitle: '那年夏天很长，长得装下了一整个世界',
    cover: 'https://readdy.ai/api/search-image?query=Youth%20romance%20series%20poster%2C%20two%20teenagers%20sitting%20on%20a%20rooftop%20in%20bright%20summer%20sunlight%2C%20laundry%20lines%20and%20potted%20plants%2C%20warm%20nostalgic%20film%20look%2C%20soft%20orange%20highlights%2C%20no%20text&width=600&height=900&seq=dollfilm-tv-our-summer&orientation=portrait',
    summary: '小城高中的四个少年，在高二的最后一个夏天里，第一次认真地想成为大人。',
    genre: ['青春', '爱情'],
    year: 2024,
    region: '国产',
    rating: 8.3,
    seasons: 1,
    episodes: 24,
    status: '完结',
    director: '许南',
    cast: ['何嘉树', '林知夏', '周朴'],
    heat: 88,
    synopsis: [
      '小城的夏天有蝉鸣、有晚自习，也有一场所有人都没准备好面对的分科考试。四个少年在同一个夏天里，各自做了一个影响很久的决定。',
      '剧集没有把青春拍成滤镜，而是把它拍成了一段潮热的、笨拙的、值得被记住的日子。',
    ],
  },
  {
    id: 'tv-valley-light',
    type: 'tvshow',
    title: '硅谷之光',
    subtitle: '代码能改变世界，也能改变一个人',
    cover: 'https://readdy.ai/api/search-image?query=Workplace%20drama%20series%20poster%2C%20modern%20glass%20office%20at%20night%20with%20warm%20desk%20lamps%20glowing%2C%20silhouettes%20at%20standing%20desks%2C%20cool%20grey%20architecture%20with%20amber%20accents%2C%20cinematic%20wide%20angle%2C%20no%20text&width=600&height=900&seq=dollfilm-tv-valley-light&orientation=portrait',
    summary: '三个华人工程师在硅谷创业，从车库到上市，也从朋友变成对手。',
    genre: ['职场', '剧情'],
    year: 2025,
    region: '欧美',
    rating: 8.6,
    seasons: 3,
    episodes: 30,
    status: '连载',
    director: 'Daniel Xu',
    cast: ['吴砚', 'Kevin Lin', '陈默'],
    heat: 87,
    synopsis: [
      '三个来自不同城市的工程师在硅谷合租一间车库，用一份演示文稿拿到了第一笔投资。十年后，公司即将上市，而他们已经有三年没有一起吃过饭。',
      '剧集把商业决策拍成了情感戏：每一次融资、每一次裁员，都是对友情的一次重新定价。',
    ],
  },
  {
    id: 'tv-homeward',
    type: 'tvshow',
    title: '归途',
    subtitle: '回家的路，走了整整二十年',
    cover: 'https://readdy.ai/api/search-image?query=Family%20drama%20series%20poster%2C%20old%20car%20on%20a%20rural%20road%20at%20sunset%2C%20golden%20wheat%20fields%20on%20both%20sides%2C%20warm%20golden%20hour%20light%2C%20nostalgic%20Chinese%20countryside%2C%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=dollfilm-tv-homeward&orientation=portrait',
    summary: '一位货车司机带着失忆的父亲上路，在千里运输线上一点点拼回父亲的过去。',
    genre: ['家庭', '剧情'],
    year: 2024,
    region: '国产',
    rating: 8.7,
    seasons: 1,
    episodes: 20,
    status: '完结',
    director: '李晚舟',
    cast: ['王砚生', '罗小满', '袁莉'],
    heat: 80,
    synopsis: [
      '父亲的记忆停留在了二十年前，唯一记得的是「要回家」。儿子把父亲带上货车副驾，沿着运输线一路向北。',
      '每一站都有父亲曾经停留过的痕迹。剧集像一部公路纪录片，把父子关系放在不断后退的路牌里重新校准。',
    ],
  },
  {
    id: 'tv-seventh-room',
    type: 'tvshow',
    title: '第七个房间',
    subtitle: '门后是你最不想面对的那段记忆',
    cover: 'https://readdy.ai/api/search-image?query=Psychological%20thriller%20series%20poster%2C%20dim%20long%20hallway%20with%20a%20single%20open%20doorway%20glowing%20amber%2C%20deep%20shadows%20and%20textured%20walls%2C%20eerie%20minimal%20composition%2C%20cinematic%20no%20text&width=600&height=900&seq=dollfilm-tv-seventh-room&orientation=portrait',
    summary: '一间心理诊所的七个咨询室，七段互相咬合的记忆，和一位记不清自己的医生。',
    genre: ['惊悚', '悬疑'],
    year: 2026,
    region: '日韩',
    rating: 8.8,
    seasons: 2,
    episodes: 24,
    status: '连载',
    director: '佐藤润',
    cast: ['高桥澪', '森下辽', '井上杏'],
    heat: 91,
    synopsis: [
      '心理医生在一栋旧楼里经营着七间咨询室。第七间从不上锁，也从不接待来访者。',
      '当一位患者在催眠中说出了只有医生自己才知道的往事，那扇门终于被推开了。',
    ],
  },
  {
    id: 'news-award-season',
    type: 'news',
    title: '第 38 届金穗奖提名揭晓，《星际回声》以九项提名领跑',
    cover: 'https://readdy.ai/api/search-image?query=Film%20festival%20red%20carpet%20at%20night%20with%20warm%20golden%20lights%2C%20elegant%20silhouettes%20of%20a%20crowd%2C%20glowing%20facade%20of%20a%20grand%20theatre%2C%20cinematic%20warm%20amber%20palette%2C%20editorial%20photography%2C%20no%20text&width=800&height=500&seq=dollfilm-news-award&orientation=landscape',
    summary: '本届金穗奖提名名单今日公布，科幻片《星际回声》拿下包括最佳影片、最佳导演在内的九项提名。',
    genre: ['行业'],
    year: 2026,
    region: '国内',
    rating: 0,
    author: '玩偶姐姐编辑部',
    date: '2026-10-15',
    articleCategory: '行业动态',
    heat: 95,
    featured: true,
    content: [
      '第 38 届金穗奖提名名单于今日上午公布。由陈叙白执导的科幻片《星际回声》共获得九项提名，包括最佳影片、最佳导演、最佳男主角、最佳摄影与最佳视觉效果，成为本届提名最多的作品。',
      '评委会在提名说明中提到，今年的候选作品在类型探索上呈现出明显的多样性：悬疑片《长夜将尽》以六项提名紧随其后，家庭题材《春潮》则拿到五项提名，构成了本届最受关注的三部作品。',
      '值得注意的是，本届最佳新导演的五位提名者中有四位是首次执导长片，其中三位作品曾在去年的青年影展中亮相。业内人士认为，这标志着国内电影工业的新一轮换代正在加速。',
      '颁奖典礼将于 11 月 8 日举行，届时还将颁发年度观众选择奖，投票通道将于本月 25 日开启。',
    ],
  },
  {
    id: 'news-boxoffice-record',
    type: 'news',
    title: '国庆档总票房破 42 亿，《深海列车》连续七日单日冠军',
    cover: 'https://readdy.ai/api/search-image?query=Cinema%20auditorium%20interior%20with%20warm%20ambient%20lighting%20and%20rows%20of%20empty%20red%20velvet%20seats%2C%20soft%20projector%20beam%20haze%2C%20cinematic%20atmosphere%2C%20muted%20warm%20tones%2C%20no%20text&width=800&height=500&seq=dollfilm-news-boxoffice&orientation=landscape',
    summary: '国庆档七日累计票房 42.3 亿元，动作科幻片《深海列车》以 11.6 亿元成绩位列档期第一。',
    genre: ['票房'],
    year: 2026,
    region: '国内',
    rating: 0,
    author: '林一舟',
    date: '2026-10-08',
    articleCategory: '市场观察',
    heat: 89,
    content: [
      '根据发行方今日公布的统计数据，今年国庆档七日累计票房达到 42.3 亿元，观影人次约 9800 万，较去年同期增长 12%。',
      '《深海列车》以 11.6 亿元位列档期第一，并连续七日拿下单日票房冠军。影片在上映第三日实现单日票房逆跌，成为近三年国庆档少见的后劲型作品。',
      '动画电影《云上邮局》以 7.8 亿元排名第二，家庭观众占比超过六成。业内分析认为，亲子观影需求的稳定释放，正在改变档期的票房结构。',
      '值得注意的是，档期内三部中小成本影片合计贡献了 9.1 亿元票房，口碑驱动的长线放映趋势愈发明显。',
    ],
  },
  {
    id: 'news-director-interview',
    type: 'news',
    title: '专访陈叙白：拍完《星际回声》之后，我重新学会了告别',
    cover: 'https://readdy.ai/api/search-image?query=Film%20director%20chair%20and%20vintage%20camera%20on%20a%20warmly%20lit%20film%20set%2C%20tungsten%20lamps%2C%20cables%20and%20storyboards%2C%20shallow%20depth%20of%20field%2C%20amber%20tones%2C%20no%20text&width=800&height=500&seq=dollfilm-news-director&orientation=landscape',
    summary: '从广告导演到科幻长片，陈叙白聊了聊他如何用一部太空电影讲述最私人的告别。',
    genre: ['人物'],
    year: 2026,
    region: '国内',
    rating: 0,
    author: '苏木',
    date: '2026-10-12',
    articleCategory: '深度访谈',
    heat: 84,
    content: [
      '采访约在后期机房。陈叙白刚结束一场混录，桌上摊着三版不同的结局分镜。他说，这部电影改了七年，最难的部分不是特效，而是承认有些告别无法完成。',
      '「我父亲走的时候，我没能赶回去。后来我一直在想，如果能给他发一条信息，我会说什么。」他停顿了一下，「所以电影里那段回声，其实是我在自问自答。」',
      '为了拍出失重感，剧组搭建了一个直径十八米的旋转舱，演员在舱内连续拍摄了二十一天。沈知遥在片中大量依靠眼神完成表演，陈叙白称这是「全片最昂贵也最省钱的镜头」。',
      '谈到未来，他表示下一部作品会回到地面：「可能是一个很小的故事，一间便利店，一个晚上。」',
    ],
  },
  {
    id: 'news-actress-profile',
    type: 'news',
    title: '沈知遥：从舞台剧到九项提名，她用了十年',
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20of%20an%20actress%20in%20warm%20studio%20lighting%2C%20soft%20amber%20backdrop%2C%20minimal%20styling%2C%20subtle%20film%20grain%2C%20high%20fashion%20magazine%20aesthetic%2C%20no%20text&width=800&height=500&seq=dollfilm-news-actress&orientation=landscape',
    summary: '在《星际回声》中用一个眼神撑起整段独白的沈知遥，谈表演、舞台与十年的等待。',
    genre: ['人物'],
    year: 2026,
    region: '国内',
    rating: 0,
    author: '顾清和',
    date: '2026-10-11',
    articleCategory: '明星动态',
    heat: 88,
    content: [
      '沈知遥的第一次电影试镜失败了，理由是她「太像舞台演员」。十年后，她在《星际回声》里有一段长达四分钟的无台词独白，被影评人称为全片的情感支点。',
      '「舞台教会我一件事：观众席再远，也能感觉到你有没有在说谎。」她说自己到现在仍然保持每周三次的台词训练，即使片场根本用不上。',
      '为了准备角色，她在航天训练中心待了两个月，学习在模拟失重环境中控制呼吸。导演陈叙白回忆，她在旋转舱里连续拍摄十四个小时后，第一句话是问「刚才那条肩膀是不是太紧了」。',
      '对于提名，她显得平静：「奖项是别人的评价，角色是自己的。拍完就交出去了。」',
    ],
  },
  {
    id: 'news-tv-trend',
    type: 'news',
    title: '短剧集崛起：12 集成为平台新宠，长剧集正在改变叙事方式',
    cover: 'https://readdy.ai/api/search-image?query=Television%20studio%20control%20room%20with%20rows%20of%20glowing%20monitors%20and%20warm%20ambient%20lighting%2C%20empty%20operator%20chairs%2C%20soft%20amber%20glow%20reflecting%20on%20glass%2C%20cinematic%20depth%2C%20no%20text&width=800&height=500&seq=dollfilm-news-tv-trend&orientation=landscape',
    summary: '今年上线的国产剧集中，12 集以内作品占比首次超过三成，观众对「密度」的要求正在提高。',
    genre: ['行业'],
    year: 2026,
    region: '国内',
    rating: 0,
    author: '玩偶姐姐编辑部',
    date: '2026-10-06',
    articleCategory: '行业动态',
    heat: 78,
    content: [
      '根据平台近期公开的片单统计，今年上线的国产剧集中，12 集以内的短剧集占比首次超过三成，较两年前提升近一倍。',
      '短剧集的兴起并不只是集数减少。多位制片人提到，剧本阶段的结构正在变化：单集必须承担完整的信息推进，传统的「两集铺垫、一集高潮」模式正在被压缩。',
      '《雾港迷案》的十六集结构被视为一个折中样本。导演邵川表示，他们在拍摄前就把每一集的结尾都当作一个小结局来设计，「观众随时可能停下，所以每一集都要值得」。',
      '不过，长剧集并未退场。家庭题材与年代题材仍然依赖长线铺陈，如何在密度与呼吸感之间找到平衡，是接下来两年行业的主要课题。',
    ],
  },
  {
    id: 'news-review-longnight',
    type: 'news',
    title: '影评｜《长夜将尽》：一间便利店里的七种人性',
    cover: 'https://readdy.ai/api/search-image?query=Stack%20of%20vintage%20film%20reels%20and%20an%20old%20projector%20on%20a%20wooden%20table%2C%20warm%20tungsten%20light%2C%20dust%20particles%20in%20the%20air%2C%20shallow%20depth%20of%20field%2C%20nostalgic%20cinema%20mood%2C%20no%20text&width=800&height=500&seq=dollfilm-news-review&orientation=landscape',
    summary: '全片 90% 的镜头没有离开过那间便利店，却拍出了今年最紧张的两个小时。',
    genre: ['影评'],
    year: 2025,
    region: '国内',
    rating: 0,
    author: '何砚之',
    date: '2025-12-18',
    articleCategory: '深度影评',
    heat: 82,
    content: [
      '《长夜将尽》最聪明的地方，是把「空间限制」变成了叙事武器。暴雨封路，七个人困在便利店里，镜头无法离开，观众也无处可逃。',
      '导演何砚对光的控制近乎偏执：冷白的顶灯、暖黄的收银台灯、冰柜透出的光，三种光源分别对应三种叙事视角。当灯管开始闪烁，观众就知道有人说了谎。',
      '影片的转折并不依赖反转，而依赖一次沉默。当摄像机里的画面播完，没有人开口的那三十秒，是全片最有力量的时刻。',
      '如果说它有什么遗憾，大概是结尾稍显仁慈。但对于一部关于人性的电影来说，仁慈本身也是一种答案。',
    ],
  },
  {
    id: 'news-festival-summer',
    type: 'news',
    title: '海边电影季公布片单，32 部经典影片将在沙滩放映',
    cover: 'https://readdy.ai/api/search-image?query=Outdoor%20summer%20film%20festival%20at%20dusk%20with%20a%20large%20glowing%20screen%20and%20warm%20string%20lights%2C%20crowd%20silhouettes%20sitting%20on%20the%20sand%2C%20deep%20orange%20sky%2C%20cinematic%20atmosphere%2C%20no%20text&width=800&height=500&seq=dollfilm-news-festival&orientation=landscape',
    summary: '为期十天的海边电影季将于下月开幕，片单包含四部 4K 修复经典与八部亚洲首映新片。',
    genre: ['活动'],
    year: 2026,
    region: '国内',
    rating: 0,
    author: '林一舟',
    date: '2026-09-28',
    articleCategory: '活动资讯',
    heat: 74,
    content: [
      '第五届海边电影季公布完整片单，今年共展映 32 部影片，其中四部为 4K 修复经典，八部为亚洲首映。',
      '放映场地仍然设在东岸沙滩，主银幕长 24 米，观众可自带坐垫入场。主办方表示，今年新增了两条接驳线路，并首次设置了无障碍观影区。',
      '开幕片为《春潮》，导演李晚舟将到场进行映后交流。闭幕片则为 4K 修复版《雾中风景》，这也是该片修复版首次在海边露天放映。',
      '电影季将于 11 月 1 日开幕，票务通道本月 20 日开启。',
    ],
  },
  {
    id: 'news-streaming-shift',
    type: 'news',
    title: '流媒体观影占比首次过半，客厅正在重新变成电影院',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20cozy%20living%20room%20at%20night%20with%20a%20large%20TV%20screen%20glowing%20warm%2C%20soft%20blanket%20on%20a%20sofa%2C%20ambient%20lamp%20light%2C%20cinematic%20interior%20photography%2C%20no%20text&width=800&height=500&seq=dollfilm-news-streaming&orientation=landscape',
    summary: '一份覆盖两万名观众的调研显示，家庭观影时长占比达到 51%，设备与内容同步升级。',
    genre: ['行业'],
    year: 2026,
    region: '国内',
    rating: 0,
    author: '顾清和',
    date: '2026-09-20',
    articleCategory: '市场观察',
    heat: 71,
    content: [
      '调研机构今日发布的一份报告显示，在覆盖两万名观众的样本中，家庭观影时长占全年观影总时长的 51%，首次超过影院观影。',
      '报告同时指出，大屏设备与音响系统的普及是主要推动力。过去两年，75 英寸以上电视的销量增长超过四成，回音壁等音频设备的家庭渗透率也明显提升。',
      '内容侧的变化同样明显：平台开始为家庭场景定制「客厅友好」的调色与混音版本，部分影片甚至提供两种画幅选择。',
      '不过，报告也提醒，家庭观影的注意力更容易分散，如何在开场十分钟内抓住观众，正成为创作者的新命题。',
    ],
  },
  {
    id: 'mv-silent-land',
    type: 'movie',
    title: '无声之境',
    subtitle: '在听不见的世界里，她学会了看',
    cover: 'https://readdy.ai/api/search-image?query=Quiet%20art%20house%20film%20poster%2C%20young%20woman%20silhouette%20in%20a%20sunlit%20empty%20room%20with%20dust%20floating%20in%20beams%2C%20soft%20cream%20and%20warm%20beige%20palette%2C%20minimal%20poetic%20composition%2C%20no%20text&width=600&height=900&seq=dollfilm-mv-silent-land&orientation=portrait',
    summary: '一位失聪的调音师学徒，用震动与触觉重新理解了声音，也重新理解了母亲的沉默。',
    genre: ['剧情', '家庭'],
    year: 2024,
    region: '中国',
    rating: 8.9,
    duration: '108 分钟',
    director: '苏木',
    cast: ['白芷', '袁莉', '许清和'],
    heat: 76,
    synopsis: [
      '女孩从小失聪，却能凭指尖的震动分辨出每一架钢琴的音准。她在旧琴行里当学徒，用手掌贴着琴箱感受声音的形状。',
      '母亲去世后，她整理遗物时发现了一叠从未寄出的信，才知道母亲当年为了让她开口说话，曾一个人学了三年手语。',
    ],
  },
  {
    id: 'mv-against-light',
    type: 'movie',
    title: '逆光',
    subtitle: '跑不快的人，也能跑完自己的那一程',
    cover: 'https://readdy.ai/api/search-image?query=Inspirational%20sports%20drama%20poster%2C%20runner%20silhouette%20against%20a%20huge%20warm%20orange%20sunset%20on%20an%20empty%20track%2C%20long%20shadows%2C%20grainy%20film%20texture%2C%20uplifting%20atmosphere%2C%20no%20text&width=600&height=900&seq=dollfilm-mv-against-light&orientation=portrait',
    summary: '因伤退役的短跑运动员回到县城中学带队，带的是一群连起跑姿势都不标准的孩子。',
    genre: ['运动', '剧情'],
    year: 2025,
    region: '中国',
    rating: 8.3,
    duration: '121 分钟',
    director: '程既白',
    cast: ['陆行舟', '何嘉树', '罗小满'],
    heat: 77,
    synopsis: [
      '曾经的省队短跑选手因伤退役，回到县城中学当体育老师。他要带的队伍只有五个人，跑道是煤渣铺的。',
      '影片没有奇迹般的夺冠，只有一群少年第一次跑完全程时，看台上的掌声。',
    ],
  },
  {
    id: 'mv-twin-flower',
    type: 'movie',
    title: '双生',
    subtitle: '镜子里的人，比她早醒了三分钟',
    cover: 'https://readdy.ai/api/search-image?query=Psychological%20mystery%20movie%20poster%2C%20mirrored%20portrait%20of%20a%20woman%20with%20one%20side%20in%20shadow%2C%20cracked%20antique%20mirror%20frame%2C%20warm%20amber%20rim%20light%20against%20deep%20charcoal%20background%2C%20eerie%20elegant%20composition%2C%20no%20text&width=600&height=900&seq=dollfilm-mv-twin-flower&orientation=portrait',
    summary: '双胞胎姐妹中的一人失踪后，留下来的那个开始怀疑，自己才是被替代的那一个。',
    genre: ['悬疑', '惊悚'],
    year: 2025,
    region: '中国',
    rating: 8.6,
    duration: '115 分钟',
    director: '何砚',
    cast: ['林蔓', '林蔓', '赵允之'],
    heat: 85,
    synopsis: [
      '姐姐失踪的第三天，妹妹搬进了她的房间。所有的东西都还在原位，包括那本写到一半的日记。',
      '日记里的字迹开始变得陌生。她第一次意识到，也许从小到大的那个「自己」，本来就有两个人。',
    ],
  },
  {
    id: 'mv-white-bird',
    type: 'movie',
    title: '白鸟',
    subtitle: '有人在等一封永远寄不到的信',
    cover: 'https://readdy.ai/api/search-image?query=Wartime%20drama%20film%20poster%2C%20lone%20figure%20in%20a%20long%20coat%20walking%20across%20a%20snowy%20empty%20field%20at%20dusk%2C%20pale%20cream%20and%20muted%20amber%20light%2C%20melancholic%20minimal%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=dollfilm-mv-white-bird&orientation=portrait',
    summary: '战争结束后的第十年，一位乡村邮递员仍在替一个不存在的人送信。',
    genre: ['剧情', '历史'],
    year: 2023,
    region: '中国',
    rating: 9.0,
    duration: '137 分钟',
    director: '李晚舟',
    cast: ['王砚生', '赵静姝', '陈立'],
    heat: 81,
    synopsis: [
      '战后的第十年，山里的邮递员每周仍会走四十里路，把一封信送到一间已经空了的屋子。',
      '信是寄给一个在战争中失踪的人。收信人不在了，但送信这件事本身，成了活着的人继续走下去的理由。',
    ],
  },
  {
    id: 'tv-seaside-room',
    type: 'tvshow',
    title: '海边的房间',
    subtitle: '一间民宿，八个来疗伤的人',
    cover: 'https://readdy.ai/api/search-image?query=Healing%20drama%20series%20poster%2C%20sunlit%20seaside%20guesthouse%20with%20white%20curtains%20billowing%2C%20wooden%20terrace%20overlooking%20calm%20sea%2C%20warm%20cream%20and%20soft%20amber%20tones%2C%20serene%20cinematic%20mood%2C%20no%20text&width=600&height=900&seq=dollfilm-tv-seaside-room&orientation=portrait',
    summary: '海边一间只接待长住客的民宿，老板娘的规矩只有一条：不许问别人的过去。',
    genre: ['治愈', '剧情'],
    year: 2026,
    region: '国产',
    rating: 8.5,
    seasons: 1,
    episodes: 12,
    status: '完结',
    director: '许南',
    cast: ['温言', '叶知秋', '孟晓'],
    heat: 83,
    synopsis: [
      '海边民宿只接受住满一个月的客人。老板娘说，三天看不出来一个人，一个月才够一个人把自己放下。',
      '十二集，八位客人。每一集是一段告别，也是一个重新开始的理由。',
    ],
  },
  {
    id: 'tv-two-cities',
    type: 'tvshow',
    title: '双城记',
    subtitle: '一条铁路，两个家庭，三十年',
    cover: 'https://readdy.ai/api/search-image?query=Period%20drama%20series%20poster%2C%20vintage%20steam%20train%20crossing%20a%20rural%20bridge%20at%20sunset%2C%20warm%20amber%20and%20sepia%20tones%2C%20nostalgic%20Chinese%20countryside%2C%20cinematic%20wide%20composition%2C%20no%20text&width=600&height=900&seq=dollfilm-tv-two-cities&orientation=portrait',
    summary: '一条铁路连接起两座城市，也连接起两个家庭三十年的恩怨与牵挂。',
    genre: ['年代', '家庭'],
    year: 2025,
    region: '国产',
    rating: 8.4,
    seasons: 1,
    episodes: 32,
    status: '完结',
    director: '裴之',
    cast: ['王砚生', '谢照', '沙立'],
    heat: 79,
    synopsis: [
      '上世纪八十年代，一趟绿皮车把两个年轻人的命运绑在了一起。三十年后，他们的孩子在同一座城市里重逢。',
      '剧集以铁路为线索，把两个家庭的变迁铺展在时代的背景里。',
    ],
  },
];

export const collections = [
  {
    id: 'col-summer-blockbuster',
    title: '深秋大片清单',
    subtitle: '从星际到深海，六部值得走进影院的作品',
    image: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20collage%20of%20warm%20orange%20sunset%20sky%20with%20dramatic%20clouds%20and%20lone%20silhouettes%2C%20atmospheric%20film%20key%20art%2C%20rich%20amber%20and%20deep%20brown%20tones%2C%20no%20text&width=900&height=600&seq=dollfilm-col-summer&orientation=landscape',
    count: '6 部影片',
  },
  {
    id: 'col-classic-review',
    title: '经典剧集回顾',
    subtitle: '那些年被反复重看的长篇叙事',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20film%20strip%20curling%20under%20a%20warm%20spotlight%20on%20a%20dark%20wooden%20surface%2C%20dust%20particles%2C%20nostalgic%20amber%20glow%2C%20minimal%20still%20life%2C%20no%20text&width=900&height=600&seq=dollfilm-col-classic&orientation=landscape',
    count: '12 部剧集',
  },
  {
    id: 'col-mystery-night',
    title: '迷雾悬疑专题',
    subtitle: '雨夜、旧案与不肯开口的人',
    image: 'https://readdy.ai/api/search-image?query=Dark%20narrow%20corridor%20lit%20by%20a%20single%20amber%20wall%20lamp%2C%20fog%20drifting%20across%20wet%20stone%20floor%2C%20deep%20shadows%2C%20tense%20mystery%20atmosphere%2C%20cinematic%20composition%2C%20no%20text&width=900&height=600&seq=dollfilm-col-mystery&orientation=landscape',
    count: '9 部作品',
  },
];

export const heroSlides = [
  {
    id: 'mv-star-echo',
    eyebrow: '本周焦点 · 科幻新作',
    title: '星际回声',
    description: '当宇宙回望时，我们听见了自己。九项金穗奖提名，年度最受关注的硬科幻长片。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%20of%20a%20futuristic%20city%20skyline%20at%20golden%20hour%20with%20dramatic%20clouds%2C%20warm%20orange%20and%20amber%20tonality%2C%20distant%20glowing%20towers%2C%20atmospheric%20haze%2C%20epic%20film%20key%20art%2C%20no%20text&width=1600&height=720&seq=dollfilm-hero-star-echo&orientation=landscape',
    meta: '2026 · 科幻 / 剧情 · 142 分钟',
    rating: '9.1',
  },
  {
    id: 'tv-fog-harbor',
    eyebrow: '热播剧集 · 每周更新',
    title: '雾港迷案',
    description: '雾散之前，没有人是清白的。老刑警与新人女警在北方港口小城重启十年旧案。',
    image: 'https://readdy.ai/api/search-image?query=Wide%20cinematic%20shot%20of%20a%20misty%20northern%20harbor%20town%20at%20dawn%2C%20thick%20fog%20over%20wooden%20piers%20and%20fishing%20boats%2C%20warm%20amber%20sunrise%20breaking%20through%2C%20moody%20atmospheric%20film%20still%2C%20no%20text&width=1600&height=720&seq=dollfilm-hero-fog-harbor&orientation=landscape',
    meta: '2026 · 悬疑 / 犯罪 · 全 16 集',
    rating: '9.0',
  },
  {
    id: 'news-award-season',
    eyebrow: '影视资讯 · 行业动态',
    title: '金穗奖提名揭晓',
    description: '第 38 届金穗奖提名名单公布，《星际回声》以九项提名领跑，颁奖典礼 11 月 8 日举行。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20view%20of%20a%20grand%20theatre%20facade%20glowing%20with%20warm%20golden%20lights%20at%20night%2C%20red%20carpet%20and%20crowd%20silhouettes%2C%20festive%20elegant%20atmosphere%2C%20amber%20and%20deep%20brown%20palette%2C%20no%20text&width=1600&height=720&seq=dollfilm-hero-award&orientation=landscape',
    meta: '2026-10-15 · 行业动态',
    rating: 'HOT',
  },
];